<template>
  <div @click="$emit('close')" class="invite-tip">
    <div class="content">
      点击右上角分享给好友，邀请好友入团
      <img src="../../../assets/share.png" />
    </div>
  </div>
</template>

<script>
export default {
  emits: ["close"],
};
</script>

<style lang="scss" scoped>
.invite-tip {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 10000;
  .content {
    margin-top: 5rem;
    display: flex;
    gap: 1rem;
    font-size: 1.2rem;
    align-items: end;
    justify-content: flex-end;
    color: white;
    img {
      height: 2.8rem;
    }
  }
}
</style>
